import React from "react"
import { navigate } from "gatsby"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { PROFILE_PAGE_URL } from "../../helpers/constants"
import { isAuthenticated } from "../../utils/utils"
import { inBrowser } from "../../helpers/omniElements"

const Profile = props => {
  // console.log("PROFILE_ADDRESS_PAGE_URL::", PROFILE_PAGE_URL)
  if (!isAuthenticated()) {
    inBrowser && navigate("/")
  }
  return (
    <Layout
      {...props}
      minHeight="10rem"
      backgroundColor={"#F8F8FA"}
      showFooterInMobile={false}
    >
      <SEO title="Account" />
      <iframe
        src={`${PROFILE_PAGE_URL}/account/profile`}
        style={{
          width: "100%",
          height: "100vh",
          border: "none",
          background: "#F8F8FA",
        }}
      />
    </Layout>
  )
}

export default Profile
